import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class EmployeeInfoApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'employee-info'
  }

  /**
   * 在职人员保存
   * @param dto 
   * @returns 
   */
  public saveEmployee(vo){
    return this.send(vo,"saveEmployee",this.Methods.POST)
  }

  /**
   * 离职人员列表
   * @param CurrentPageIndex 
   * @param PageSize 
   * @param dto 
   * @returns 
   */
  public getEmployeePage(CurrentPageIndex,PageSize,dto){
    return this.send(dto,"getEmployeePage?CurrentPageIndex="+CurrentPageIndex+"&PageSize="+PageSize,this.Methods.GET)
  }

  /**
   * 离职员工详情
   * @param Id 
   * @returns 
   */
  public getEmployeeLeaveOne(Id){
    return this.send({Id:Id},"getEmployeeLeaveOne",this.Methods.GET)
  }


  /**
   * 离职员工导出查询
   * @param params 
   * @returns 
   */
  public getList(params){
    return this.send(params,"getList",this.Methods.GET)
  }


  /**
   * 根据关联登陆账号查询员工信息
   * @param UserCode 
   * @returns 
   */
   public getEmployeeOne(UserCode){
    return this.send({UserCode:UserCode},"getEmployeeOne",this.Methods.GET)
  }



}